$(document).ready(function() {
  // 250311 이형옵션 상품 add to cart 버튼 숨김 처리
  $('.product-card').each(function() {
    var productCard = $(this);
    
    // 현재 product-card 내부에 product-card__variant--size 요소가 있는지 확인
    if (productCard.find('.product-card__variant--size').length > 0) {
      productCard.find('.product-card__btn--wrapper').hide();
      productCard.find('.product-card__variant--size').hide();
    }
  });
});



// 250327 이형옵션 사이드바 스크롤시 없애기 추가 
$(document).ready(function(){
  var imageId = "", thumbId = "", imageOffset = 0, scrollH = 0;

    // 1. 모바일 사이즈 상세이미지 썸네일로 변경
    $(window).on('load resize orientationchange', function() {
      $('.product-photo-container').each(function() {
          var $carousel = $(this);
          /* Initializes a slick carousel only on mobile screens */
          // slick on mobile
          if ($(window).width() > 1200) {
              if ($carousel.hasClass('slick-initialized')) {
                  $carousel.slick('unslick');
              }
          } else {
              if (!$carousel.hasClass('slick-initialized')) {
                  $carousel.slick({
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      mobileFirst: true,
                      dots: true
                  });
              }
          }
      });
    });

  
  var offset2 = $('.product_top').next().offset(); //선택한 태그의 위치를 반환

  var $header = $('.site-header'),
      $productInformation = $('.product-shop'),
      $sidebar = $('.slider-nav'),
      $imageList = $('.product-photo-container');
  
  if ($header.length || $productInformation.length) {
      $(window).scroll(function () {
        
          // 3. Left, Right Side Fix
          // console.log("bbb")
          
          var box = $('.bottom-box').offset().top; // bottom의 위치

          // console.log("Box Position: ", box);
          if(($(window).scrollTop() + $productInformation.outerHeight()) > box){
            $productInformation.addClass("scroll-stopped-on");
            $sidebar.addClass("scroll-stopped-on");
          }else{
            $productInformation.removeClass("scroll-stopped-on");
            $sidebar.removeClass("scroll-stopped-on");
          }
        
          scrollH = $(window).scrollTop();
          imageId = "#product-featured-image-"+48513184465183;
          thumbId = "#product-thumb-image-"+48513184465183;
          imageOffset = $(imageId).offset().top;
        
          if( ( imageOffset - $(imageId).outerHeight() < scrollH ) &&  ( scrollH < imageOffset ) ) {
            $(thumbId).addClass("is_selected");
          } else {
            if($(thumbId).hasClass("is_selected")) {
              $(thumbId).removeClass("is_selected");
            }
          }
      
          $(thumbId).on('click', function (e) {
            $(window).animate({
                scrollTop: offset2.top
            }, 500);
          });
      });
  }
});  